export default {
    namespaced: true,
    state: {
        transactionType: 2,
        transactionOptions: {
            agent: !!+localStorage.getItem('trans_agent') || false,
            comment: !!+localStorage.getItem('trans_comment') || false,
            tags: !!+localStorage.getItem('trans_tags') || false,
            category: !!+localStorage.getItem('trans_category') || false,
            calendar: !!+localStorage.getItem('trans_calendar') || false,
        }
    },
    getters: {
        transactionOption: (state) => (name) => state.transactionOptions[name]
    },
    mutations: {
        setType(state, val) {
            state.transactionType = val;
        },
        setOption(state, optionName) {
            state.transactionOptions[optionName] = !state.transactionOptions[optionName]
            localStorage.setItem(`trans_${optionName}`, +state.transactionOptions[optionName])
        },
    }
}